// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__35d3V","label":"SetPasswdForm_label__2OtyR"};